import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  DialogTitle,
  TableRow,
  TableCell,
  TableHead,
  Table,
  TableContainer,
  Grid,
  TableBody,
} from "@mui/material";
import { connect, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { START_GLOBAL_SETTING_ACCESS } from "Actions/RepeatOrderAction";
import TableEmptyState from "Components/Common/Table/TableEmptyState";
import clsx from "clsx";
const useStyle = makeStyles((theme) => ({
  rsAccessMain: {
    display: "flex",
    justifyContent: "flex-start",
    paddingBottom: "10px",
    "&>h5": {
      paddingRight: "5px",
    },
  },
  rsAlignMain: {
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  tableBody: {
    "& .MuiTableContainer-root": {
      maxHeight: "calc(80vh - 200px) !important",
      padding: "0px !important",
    },
    "&>tr": {
      "&>td": {
        padding: "14px 20px !important",
      },
    },
  },
  tableHead: {
    "&>tr": {
      "&>td": {
        paddingLeft: "10px",
        paddingRight: "10px",
      },
    },
  },
  tableContainer: {
    marginBottom: "20px !important",
    height: "auto !important",
    padding: "0",
  },
  rsDialogContent: {
    paddingTop: "0px !important",
  },
  rsDialogMainRoot: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      [theme.breakpoints.down("1102")]: {
        maxWidth: "75% !important",
      },
    },
  },
}));

const AccessDialog = (props) => {
  const { open, setOpen, getGlobalSettingAccessAction, globalSettingAccess } =
    props;
  const classes = useStyle();
  const loginUserDetail = useSelector((state) => state.user);
  const [accessData, setAccessData] = useState([]);
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (
      loginUserDetail?.loginUserDetail?.data?.data?.is_manage_settings === false
    ) {
      getGlobalSettingAccessAction();
    }
  }, []);
  useEffect(() => {
    if (
      globalSettingAccess?.data?.length > 0 &&
      globalSettingAccess?.loading === false
    ) {
      setAccessData(globalSettingAccess?.data);
    }
  }, [globalSettingAccess?.data]);
  return (
    <>
      <Dialog
        open={open}
        maxWidth={"md"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={clsx("rsDialogMain", classes.rsDialogMainRoot)}
      >
        <DialogTitle>
          <Typography>
            You do not have permission to update settings. Please contact the
            following users.
          </Typography>{" "}
        </DialogTitle>
        <DialogContent className={classes.rsDialogContent}>
          <Box className={classes.rsAlignMain}>
            <Grid className="common-table">
              <TableContainer className={classes.tableContainer}>
                <Table stickyHeader>
                  <TableHead className={classes.tableHead}>
                    <TableRow>
                      <TableCell>NAME</TableCell>
                      <TableCell>EMAIL</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className={classes.tableBody}>
                    {accessData?.map((item, key) => {
                      return (
                        <>
                          <TableRow>
                            <TableCell>{item?.name}</TableCell>
                            <TableCell>{item?.email}</TableCell>
                          </TableRow>
                        </>
                      );
                      {
                        /* })} */
                      }
                    })}
                  </TableBody>
                  {globalSettingAccess?.data?.length <= 0 && (
                    <>
                      <TableEmptyState />
                    </>
                  )}
                </Table>
              </TableContainer>
            </Grid>
          </Box>
        </DialogContent>
        {/* <DialogContent>
          <Box className={classes.rsAlignMain}>
            <Box className={classes.rsAccessMain}>
              <Typography variant="h5" fontSize={"18px !important"} medium>
                Name:
              </Typography>
              <Typography variant="h4" fontSize={"18px !important"} medium>
                {
                  loginUserDetail?.loginUserDetail?.data?.data
                    ?.setting_access_detail?.name
                }
              </Typography>
            </Box>
            <Box className={classes.rsAccessMain}>
              <Typography variant="h5" fontSize={"18px !important"} medium>
                Email:
              </Typography>
              <Typography variant="h4" fontSize={"18px !important"} medium>
                {
                  loginUserDetail?.loginUserDetail?.data?.data
                    ?.setting_access_detail?.email
                }
              </Typography>
            </Box>
          </Box>
        </DialogContent> */}
        <DialogActions>
          <Button variant="outlined" onClick={() => handleClose()}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  globalSettingAccess: state.order.globalSettingAccess,
});
const mapDispatchToProps = (dispatch) => ({
  getGlobalSettingAccessAction: () =>
    dispatch({ type: START_GLOBAL_SETTING_ACCESS }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessDialog);
